'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionAnimation = getTransitionAnimation;
var transitionAnimations = {
  fade: function fade() {
    return {
      'enter': {
        'style': {
          'opacity': 0
        },
        'animation': {
          'opacity': 1
        }
      },
      'leave': {
        'style': {
          'opacity': 1
        },
        'animation': {
          'opacity': 0
        }
      }
    };
  },
  pushright: function pushright(width) {
    // Push to the left, yeah seriously
    return {
      'enter': {
        'style': {
          'translateX': '100%'
        },
        'animation': {
          'translateX': 0
        }
      },
      'leave': {
        'style': {
          'translateX': 0
        },
        'animation': {
          'translateX': '-100%'
        }
      }
    };
  },
  pushleft: function pushleft(width) {
    // Push to the right, yeah seriously
    return {
      'enter': {
        'style': {
          'translateX': '-' + width + 'px'
        },
        'animation': {
          'translateX': 0
        }
      },
      'leave': {
        'style': {
          'translateX': 0
        },
        'animation': {
          'translateX': width + 'px'
        }
      }
    };
  },
  'slide-left': function slideLeft(width) {
    // Slide to the right, yeah seriously
    return {
      'enter': {
        'style': {
          'translateX': '-' + width + 'px'
        },
        'animation': {
          'translateX': 0
        }
      },
      'leave': {
        'style': {
          'translateX': 0
        },
        'animation': {
          'translateX': width + 'px'
        }
      }
    };
  },
  slide: function slide(width) {
    // Slide to the left
    return {
      'enter': {
        'style': {
          'translateX': width + 'px'
        },
        'animation': {
          'translateX': 0
        }
      },
      'leave': {
        'style': {
          'translateX': 0
        },
        'animation': {
          'translateX': '-' + width + 'px'
        }
      }
    };
  },
  slideup: function slideup(height) {
    return {
      'enter': {
        'style': {
          'translateY': height + 'px',
          'zIndex': 11
        },
        'animation': {
          'translateY': 0
        }
      },
      'leave': {
        'style': {
          'translateY': 0,
          'zIndex': 10
        },
        'animation': {
          'translateY': 0
        }
      }
    };
  },
  slidedown: function slidedown(height) {
    return {
      'enter': {
        'style': {
          'translateY': '-' + height + 'px',
          'zIndex': 10
        },
        'animation': {
          'translateY': 0
        }
      },
      'leave': {
        'style': {
          'translateY': 0,
          'zIndex': 11
        },
        'animation': {
          'translateY': height + 'px'
        }
      }
    };
  },
  pop: function pop() {
    return {
      'enter': {
        'style': {
          'scale': 0.2
        },
        'animation': {
          'scale': 1
        }
      },
      'leave': {
        'style': {
          'scale': 1
        },
        'animation': {
          'scale': 0.2
        }
      }
    };
  }
};
var NO_OP = {
  'enter': {
    'style': {},
    'animation': {}
  },
  'leave': {
    'style': {},
    'animation': {}
  }
};

function getTransitionAnimation(transition, width, height) {
  var transitionsFactory = transitionAnimations[transition];

  if (!transitionsFactory) {
    return NO_OP;
  }

  return transitionsFactory(width, height);
  ;
}